export default function createDocumentMetrics() {
    const doc = window.document;
    const docSize = doc.querySelectorAll('*').length;
    const scripts = Array.from(doc.querySelectorAll('script'));
    const stylesheets = Array.from(doc.querySelectorAll('link')).filter(
        ({ rel }) => rel === 'stylesheet',
    );
    // CSS is render blocking by default
    // Maybe the blocking scripts should only be ones that are in the <head>.
    const blockingScripts = scripts.filter(
        (script) => !(script.defer || script.async),
    );

    return {
        document_script_count: scripts.length,
        document_stylesheet_count: stylesheets.length,
        document_blocking_resource_count: blockingScripts.length,
        document_dom_depth: docSize,
    };
}
